'use client';

import NextLink from 'next/link';
import type { ComponentProps } from 'react';
import { useTranslation } from '@/i18n/LanguageProvider';

type NextLinkProps = ComponentProps<typeof NextLink>;

// La implementación vive en '@/i18n/localizeHref' (módulo sin 'use client')
// para que también puedan usarla los server components. Se reexporta aquí
// para no romper los imports existentes.
export { localizeHref } from '@/i18n/localizeHref';
import { localizeHref } from '@/i18n/localizeHref';

/**
 * Reemplazo de `next/link` que conserva el idioma de la URL: en una
 * página `/ca/...`, un `href="/guias"` se navega a `/ca/guias`. Sin esto,
 * cualquier enlace interno volvería al español y se perdería el idioma.
 */
export default function LocaleLink({ href, ...rest }: NextLinkProps) {
  const { locale } = useTranslation();
  const localized = typeof href === 'string' ? localizeHref(href, locale) : href;
  return <NextLink href={localized} {...rest} />;
}
